export const cityLatLong = [
  { name: 'Albuquerque', lat: 35.0844, long: -106.6504 },
  { name: 'Anchorage', lat: 61.2181, long: -149.8631 },
  { name: 'Arlington', lat: 32.7357, long: -97.1081 },
  { name: 'Aurora', lat: 39.7294, long: -104.8319 },
  { name: 'Boston', lat: 42.3601, long: -71.0589 },
  { name: 'Cambridge', lat: 42.3736, long: -71.1097 },
  { name: 'Chicago', lat: 41.8781, long: -87.6298 },
  { name: 'Elizabeth', lat: 40.6620, long: -74.2105 },
  { name: 'Fairbanks', lat: 64.2008, long: -147.7224 },
  { name: 'Fort Wayne', lat: 41.0793, long: -85.1394 },
  { name: 'Henderson', lat: 36.0395, long: -114.9817 },
  { name: 'Honolulu', lat: 21.3069, long: -157.8583 },
  { name: 'Indianapolis', lat: 39.7684, long: -86.1581 },
  { name: 'Jacksonville', lat: 30.3322, long: -81.6557 },
  { name: 'Juneau', lat: 58.3019, long: -134.4197 },
  { name: 'Las Vegas', lat: 36.1699, long: -115.1398 },
  { name: 'Los Angeles', lat: 34.0522, long: -118.2437 },
  { name: 'Mesa', lat: 33.4152, long: -111.8315 },
  { name: 'Miami', lat: 25.7617, long: -80.1918 },
  { name: 'Paterson', lat: 40.9116, long: -74.1627 },
  { name: 'Pearl City', lat: 21.3982, long: -157.9747 },
  { name: 'Phoenix', lat: 33.4484, long: -112.0740 },
  { name: 'Reno', lat: 39.5296, long: -119.8138 },
  { name: 'Richmond', lat: 37.5407, long: -77.4360 },
  { name: 'Rio Rancho', lat: 35.2334, long: -106.6631 },
  { name: 'San Diego', lat: 32.7157, long: -117.1611 },
  { name: 'San Francisco', lat: 37.7749, long: -122.4194 },
  { name: 'Santa Fe', lat: 35.6870, long: -105.9378 },
  { name: 'Tucson', lat: 32.2226, long: -110.9747 },
  { name: 'Waipahu', lat: 21.3965, long: -158.0084 }
];


export const stateLatLong = [
  { name: 'Alaska', lat: 61.3704, long: -152.4044 },
  { name: 'Arizona', lat: 33.7298, long: -111.4312 },
  { name: 'California', lat: 36.1162, long: -119.6816 },
  { name: 'Florida', lat: 27.7663, long: -81.6868 },
  { name: 'Hawaii', lat: 21.0943, long: -157.4983 },
  { name: 'Illinois', lat: 40.3495, long: -88.9861 },
  { name: 'Indiana', lat: 39.8494, long: -86.2583 },
  { name: 'Massachusetts', lat: 42.3650, long: -71.1056 },
  { name: 'Nevada', lat: 38.3135, long: -117.0554 },
  { name: 'New Jersey', lat: 40.2989, long: -74.5210 },
  { name: 'New Mexico', lat: 34.8405, long: -106.2485 },
  { name: 'Virginia', lat: 37.7693, long: -78.1699 },
  { name: 'Atlanta', lat: 33.7490, long: -84.3880 }
];


export const getLatLongByNames = (locationNames: string[] | undefined, dataType: 'city' | 'state'): [number, number] => {
  // Default return if input is empty
  if (!locationNames || locationNames.length === 0) return [45, -60];

  // Determine which dataset to use based on the `dataType`
  const dataset = dataType === 'city' ? cityLatLong : stateLatLong;

  // Find coordinates for the provided names (city or state)
  const coordinates = locationNames.map(locationName => {
    const location = dataset.find(entry => entry.name.toLowerCase() === locationName.toLowerCase());
    return location ? [location.lat, location.long] as [number, number] : null; // Use type assertion
  }).filter((coord): coord is [number, number] => coord !== null); // Filter out null values safely

  // Default return if no valid locations found
  if (coordinates.length === 0) return [45, -60];

  // Calculate the bounding box for multiple cities/states
  const latitudes = coordinates.map(coord => coord[0]); // Extract latitudes
  const longitudes = coordinates.map(coord => coord[1]); // Extract longitudes

  const minLat = Math.min(...latitudes);
  const maxLat = Math.max(...latitudes);
  const minLong = Math.min(...longitudes);
  const maxLong = Math.max(...longitudes);

  const centerLat: number = (minLat + maxLat) / 2; // Calculate center latitude
  const centerLong: number = (minLong + maxLong) / 2; // Calculate center longitude

  // Return the center point of the bounding box
  return [centerLat, centerLong];
};